import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { useBreakpoints } from '../../../../../../bookings/util/useBreakpoints';
import { LinkProps } from '../../../../../../common/components/Link';
import { CtaButtonBoxWithExperiment, TapTarget } from './CtaLinkWithExperiment.styles';

export type CtaLinkProps = PropsWithChildren<LinkProps>;

export const CtaLinkWithTapTarget = styled(({ children, ...props }: CtaLinkProps) => {
  const isMobile = useBreakpoints().Small;

  return (
    <>
      {isMobile && (
        <TapTarget {...props}>
          <CtaButtonBoxWithExperiment>{children}</CtaButtonBoxWithExperiment>
        </TapTarget>
      )}

      {!isMobile && <CtaButtonBoxWithExperiment>{children}</CtaButtonBoxWithExperiment>}
    </>
  );
})``;
